import { useEffect, useRef } from "react";
import { useFormikContext } from "formik";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";

export const FormikEffect = ({ onChange }) => {
  const { values: next } = useFormikContext();
  const ref = useRef(next);

  useEffect(() => {
    const { current: prev } = ref;

    if (typeof onChange === "function" && !isEqual(prev, next)) {
      onChange(prev, next);
    }

    ref.current = next;
  }, [next, onChange]);

  return null;
};

FormikEffect.propTypes = {
  onChange: PropTypes.func,
};
